// 按箱入库流程
export const storageByBoxColumns = [
  {
    type: 'select',
    fixed: 'left',
  },
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'box_num',
    label: '箱编号',
    minWidth: '160px',
    fixed: 'left',
  },
  {
    prop: 'factory',
    label: '生产厂商',
    minWidth: '100px',
  },
  // {
  //   prop: 'logic_warehouse',
  //   label: '归属方',
  //   minWidth: '100px',
  // },
  {
    prop: 'dept_name',
    label: '归属部门',
    minWidth: '100px',
  },
  {
    prop: 'product_model',
    label: '箱规格',
    minWidth: '270px',
  },
  {
    prop: 'idc_unit',
    label: '机房管理单元',
    minWidth: '220px',
  },
  {
    prop: 'logic_warehouse',
    label: '逻辑库',
    minWidth: '100px',
  },
  {
    prop: 'scan_box_num',
    label: '扫描箱编号',
    minWidth: '160px',
  },
  {
    prop: 'store_name',
    label: '资产库',
    minWidth: '250px',
  },
  {
    prop: 'shelf_name',
    label: '资产架',
    minWidth: '130px',
  },
  {
    prop: 'pos_name',
    label: '资产位',
    minWidth: '110px',
  },
];

// 按箱出库流程
export const exportByBoxColumns = [
  {
    type: 'select',
    fixed: 'left',
  },
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'product_model',
    label: '箱规格',
    minWidth: '500px',
  },
  {
    prop: 'logic_warehouse',
    label: '逻辑库',
    minWidth: '100px',
  },
  {
    prop: 'dept_name',
    label: '归属部门',
    minWidth: '100px',
  },
  {
    prop: 'box_count',
    label: '箱数',
    minWidth: '50px',
  },
  {
    prop: 'scan_box_num',
    label: '已扫描箱编号',
    minWidth: '200px',
  },
];

// 设施入库流程 -审批
export const facilitiesWarehousingApprovalColumns = [
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'assets_type',
    label: '资产类型',
    minWidth: '120px',
    fixed: 'left',
  },
  {
    prop: 'asset_manage_mode',
    label: '管理方式',
    minWidth: '80px',
  },
  {
    prop: 'pn',
    label: '型号',
    minWidth: '120px',
  },
  {
    prop: 'logic_name',
    label: '逻辑库',
    minWidth: '80px',
  },
  {
    prop: 'enabled',
    label: '是否可用',
    minWidth: '80px',
  },
  {
    prop: 'asset_id',
    label: '固资',
    minWidth: '120px',
  },
  {
    prop: 'sn',
    label: 'SN',
    minWidth: '120px',
  },
  {
    prop: 'asset_count',
    label: '数量',
    minWidth: '60px',
  },
];

// 设施入库流程
export const facilityAssetsIntoStorageColumns = [
  {
    type: 'select',
    fixed: 'left',
  },
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'assets_type',
    label: '资产类型',
    minWidth: '120px',
    fixed: 'left',
  },
  {
    prop: 'asset_manage_mode',
    label: '管理方式',
    minWidth: '80px',
  },
  {
    prop: 'pn',
    label: '型号',
    minWidth: '120px',
  },
  {
    prop: 'logic_name',
    label: '逻辑库',
    minWidth: '80px',
  },
  {
    prop: 'enabled',
    label: '是否可用',
    minWidth: '80px',
  },
  {
    prop: 'asset_id',
    label: '固资',
    minWidth: '120px',
  },
  {
    prop: 'sn',
    label: 'SN',
    minWidth: '120px',
  },
  {
    prop: 'asset_count',
    label: '数量',
    minWidth: '60px',
  },
  {
    prop: 'scan_sn',
    label: '扫描SN',
    minWidth: '120px',
  },
  {
    prop: 'store_name',
    label: '资产库',
    minWidth: '120px',
  },
  {
    prop: 'rack_name',
    label: '资产架',
    minWidth: '100px',
  },
  {
    prop: 'pos_name',
    label: '资产位',
    minWidth: '90px',
  },
];

// 设施出库流程 - 审批
export const facilitiesOutOfTheWarehouseApprovalColumns = [
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'assets_type',
    label: '资产类型',
    minWidth: '120px',
    fixed: 'left',
  },
  {
    prop: 'asset_manage_mode',
    label: '管理方式',
    minWidth: '80px',
  },
  {
    prop: 'pn',
    label: '型号',
    minWidth: '120px',
  },
  {
    prop: 'logic_name',
    label: '逻辑库',
    minWidth: '80px',
  },
  {
    prop: 'enabled',
    label: '是否可用',
    minWidth: '80px',
  },
  {
    prop: 'asset_id',
    label: '固资',
    minWidth: '120px',
  },
  {
    prop: 'sn',
    label: 'SN',
    minWidth: '120px',
  },
  {
    prop: 'asset_count',
    label: '数量',
    minWidth: '60px',
  },
  {
    prop: 'store_name',
    label: '存放房间',
    minWidth: '90px',
  },
];
// 设施出库
export const facilityAssetsOutOfStorageColumns = [
  {
    type: 'select',
    fixed: 'left',
  },
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'assets_type',
    label: '资产类型',
    minWidth: '120px',
    fixed: 'left',
  },
  {
    prop: 'asset_manage_mode',
    label: '管理方式',
    minWidth: '80px',
  },
  {
    prop: 'pn',
    label: '型号',
    minWidth: '120px',
  },
  {
    prop: 'logic_name',
    label: '逻辑库',
    minWidth: '80px',
  },
  {
    prop: 'enabled',
    label: '是否可用',
    minWidth: '80px',
  },
  {
    prop: 'asset_id',
    label: '固资',
    minWidth: '120px',
  },
  {
    prop: 'sn',
    label: 'SN',
    minWidth: '120px',
  },
  {
    prop: 'asset_count',
    label: '数量',
    minWidth: '60px',
  },
  {
    prop: 'scan_sn',
    label: '扫描SN',
    minWidth: '120px',
  },
  {
    prop: 'store_name',
    label: '资产库',
    minWidth: '120px',
  },
  {
    prop: 'rack_name',
    label: '资产架',
    minWidth: '100px',
  },
  {
    prop: 'pos_name',
    label: '资产位',
    minWidth: '90px',
  },

  {
    prop: 'store_name',
    label: '存放房间',
    minWidth: '90px',
  },
];
// 网络资产挪库
export const networkAssetRemovalColumns = [
  {
    type: 'select',
    fixed: 'left',
  },
  {
    prop: 'seq_id',
    label: '序号',
    minWidth: '60px',
    fixed: 'left',
  },
  {
    prop: 'asset_type',
    label: '设备类型',
    minWidth: '100px',
    fixed: 'left',
  },
  {
    prop: 'manage_mode',
    label: '管理方式',
    minWidth: '70px',
  },
  {
    prop: 'company',
    label: '厂商',
    minWidth: '90px',
  },
  {
    prop: 'pn',
    label: '现PN',
    minWidth: '200px',
  },
  {
    prop: 'sn',
    label: '挪库SN',
    minWidth: '100px',
  },
  {
    prop: 'outDeptName',
    label: '现部门',
    minWidth: '90px',
  },
  {
    prop: 'outLib',
    label: '现逻辑库',
    minWidth: '90px',
  },
  {
    prop: 'outWay',
    label: '现出库方式',
    minWidth: '80px',
  },
  {
    prop: 'inLib',
    label: '挪库后逻辑库',
    minWidth: '90px',
  },
  {
    prop: 'inWay',
    label: '挪库后出库方式',
    minWidth: '80px',
  },
  {
    prop: 'inDeptName',
    label: '挪库后部门',
    minWidth: '90px',
  },
  {
    prop: 'scan_sn',
    label: '扫描SN',
    minWidth: '130px',
  },
  {
    prop: 'store_name',
    label: '资产库',
    minWidth: '120px',
  },
  {
    prop: 'rack_name',
    label: '资产架',
    minWidth: '90px',
  },

  {
    prop: 'pos_name',
    label: '资产位',
    minWidth: '80px',
  },
];

// 服务器非标
export const server_non_standard_Columns = [
  {
    type: 'index',
    label: '序号',
    minWidth: '80',
    fixed: 'left',
  },
  {
    prop: 'idc_name',
    label: '机房管理单元',
    minWidth: '160',
    fixed: 'left',
  },
  {
    prop: 'shelf_name',
    label: '机架',
    minWidth: '120',
  },
  {
    prop: 'pos_name',
    label: '机位',
    minWidth: '90',
  },

  {
    prop: 'asset_id',
    label: '固资编号',
    minWidth: '140',
  },
  {
    prop: 'sn',
    label: 'SN',
    minWidth: '120',
  },
  {
    prop: 'device_type',
    label: '设备型号',
    minWidth: '120',
  },
  {
    prop: 'three_level_service',
    label: '三级业务',
    minWidth: '140',
  },
  {
    prop: 'applicant_name',
    label: '申请人',
    minWidth: '100',
  },
];

